/** Messages of the intelligence upgrade (FX, timeframes, news, multi-timeframe, scoring, validation). Each key exists in both languages. */
export const intel = {
  en: {
    "err.timeframeUnsupported": "{provider} does not provide the {tf} timeframe.",

    "news.type.earnings": "Earnings",
    "news.type.guidance": "Guidance",
    "news.type.mna": "M&A",
    "news.type.rates": "Interest rates",
    "news.type.inflation": "Inflation",
    "news.type.labor": "Labour market",
    "news.type.regulation": "Regulation / legal",
    "news.type.crypto": "Crypto",
    "news.type.company": "Company news",
    "news.type.market": "Market news",
    "news.type.data": "Economic data",
  } as Record<string, string>,
  de: {
    "err.timeframeUnsupported": "{provider} bietet die Zeitebene {tf} nicht an.",
    "news.type.earnings": "Quartalszahlen",
    "news.type.guidance": "Prognose",
    "news.type.mna": "Übernahme / Fusion",
    "news.type.rates": "Zinsen",
    "news.type.inflation": "Inflation",
    "news.type.labor": "Arbeitsmarkt",
    "news.type.regulation": "Regulierung / Recht",
    "news.type.crypto": "Krypto",
    "news.type.company": "Unternehmensnews",
    "news.type.market": "Marktnews",
    "news.type.data": "Wirtschaftsdaten",
  } as Record<string, string>,
};
